import React from 'react';
import PropTypes from 'prop-types';

import SingleSelect from '../../formElements/SingleSelect';

import form from '../../../commonStyles/formStyles.module.css';

const FilterContentAppointment = ({
    appointmentTypes,
    appointmentUsers,
    attendanceStatuses,
    selects,
    errors,
    onFilterChange
}) => {

    // RENDER
    return (
        <div className={form.formSection} data-testid="form_start">
            <div className={form.formColumn}>
                <SingleSelect
                    id="appointmentTypeId"
                    label="Available Appointment Type"
                    placeholder="Select appointment type..."
                    customClass="absoluteAndHeightControlSecondLevel"
                    menuItems={appointmentTypes || []}
                    selectedId={selects.appointmentTypeId || ''}
                    selected={
                        (selects.appointmentTypeId?.id &&
                            appointmentTypes.find(
                                (el) => el.id === selects.appointmentTypeId.id
                            )) ||
                        {}
                    }
                    onChange={(id) =>
                        onFilterChange(
                            'appointmentTypeId',
                            appointmentTypes.find((el) => el.id === id)
                        )
                    }
                />
                <SingleSelect
                    id="userId"
                    label="Available User"
                    placeholder="Select user..."
                    customClass="absoluteAndHeightControl"
                    capitalizeList={false}
                    menuItems={appointmentUsers || []}
                    selectedId={selects.userId?.id || ''}
                    selected={
                        (selects.userId?.id &&
                            appointmentUsers.find((el) => el.id === selects.userId.id)) ||
                        {}
                    }
                    onChange={(id) =>
                        onFilterChange(
                            'userId',
                            appointmentUsers.find((el) => el.id === id)
                        )
                    }
                />
            </div>
            <div className={form.formColumn}>
                <SingleSelect
                    id="attendanceStatusId"
                    label="Available Attendance Status"
                    placeholder="Select attendance status..."
                    customClass="absoluteAndHeightControlSecondLevel"
                    menuItems={attendanceStatuses || []}
                    selectedId={selects.attendanceStatusId?.id || ''}
                    selected={
                        (selects.attendanceStatusId?.id &&
                            attendanceStatuses.find(
                                (el) => el.id === selects.attendanceStatusId.id
                            )) ||
                        {}
                    }
                    error={errors.filter}
                    onChange={(id) =>
                        onFilterChange(
                            'attendanceStatusId',
                            attendanceStatuses.find((el) => el.id === id)
                        )
                    }
                />
            </div>
        </div>
    );
};

FilterContentAppointment.propTypes = {
    appointmentTypes: PropTypes.arrayOf(PropTypes.object),
    appointmentUsers: PropTypes.arrayOf(PropTypes.object),
    attendanceStatuses: PropTypes.arrayOf(PropTypes.object),
    selects: PropTypes.object,
    errors: PropTypes.object,
    onFilterChange: PropTypes.func
};

export default FilterContentAppointment;
